import React from 'react';
import { Link } from 'react-router-dom';
import type { SwampEventSummary } from '../types';

interface TrophyCardProps {
   event: SwampEventSummary;
}

export function TrophyCard({ event }: TrophyCardProps) {
   const base = process.env.PUBLIC_URL || '';
   const imageSrc = event.image.startsWith('/') ? `${base}${event.image}` : event.image;

   return (
      <Link to={`/swamp/event/${event.id}`} className="swamp-trophy-card">
         <img src={imageSrc} alt={event.title} className="swamp-trophy-card__image" />
         <span className="swamp-trophy-card__title">{event.title}</span>
      </Link>
   );
}
